import { HW_API_URL } from "../../configs";
import { fetcher } from "../../libs";

import { ServiceCheckPayload, ServiceCheckResponse } from "./types";

/**
 * Transport-only migration (docs/migrations/servicecheck/07-frontend-migration.md).
 * The Node endpoint reproduces the legacy wire shape exactly, so `useNode` changes
 * nothing except where the request goes. The absolute URL bypasses the axios
 * baseURL but every fetcher interceptor still applies — request snake_casing,
 * response camelizing, and the throw-on-404 the workflow engine's not-serviced
 * navigation depends on. Direct concatenation is safe here: booking-v4 sets
 * `VITE_HW_API_URL` to the bare `/api` mount in every environment.
 *
 * `useNode` is the `HunkWare_Service_Coverage_And_Booking_Availability_Migration`
 * flag. Roll back by turning the flag off — no deploy needed.
 */
export const serviceCheck = ({
  useNode = false,
  ...payload
}: ServiceCheckPayload & { useNode?: boolean }) =>
  fetcher.post<ServiceCheckResponse>(
    useNode ? `${HW_API_URL}/v1/public/website/servicecheck` : "/servicecheck",
    payload,
  );
